export default (hasError) => ({
  control: (provided, state) => ({
    ...provided,
    borderColor: hasError ? "#a90329" : "#bdbdbd",
    minHeight: 32
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    padding: "4px 8px"
  }),
  indicatorSeparator: (provided, state) => ({
    ...provided,
    marginBottom: 4,
    marginTop: 4
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    ...(hasError ? { backgroundColor: "#fff0f0" } : null)
  })
});

/**
 * Styles options for the Select component
 */

// clearIndicator
// container
// control
// dropdownIndicator
// group
// groupHeading
// indicatorsContainer
// indicatorSeparator
// input
// loadingIndicator
// loadingMessage
// menu
// menuList
// menuPortal
// multiValue
// multiValueLabel
// multiValueRemove
// noOptionsMessage
// option
// placeholder
// singleValue
// valueContainer
